/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const CListeObjets = require('./CListeObjets')
const numeroVersionPrototypes = 6; // Numéro de version correspondant à la version Java 5.2.2
module.exports = CPrototype

/**
 * Classe représentant une macro construction.
 * Les éventuels prototypes de la figure sont enregistrés par CMathGraphDoc.
 * @constructor
 * @extends CListeObjets
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @returns {CPrototype}
 */
function CPrototype (listeProprietaire) {
  CListeObjets.call(this, listeProprietaire);
}
CPrototype.prototype = new CListeObjets();
CPrototype.prototype.constructor = CPrototype;
CPrototype.prototype.superClass = "CListeObjets";
CPrototype.prototype.className = "CPrototype";

CPrototype.prototype.indexOf = function(o) {
  var elb = o;
  if (elb === null) return -1;
  if (elb.elementGeneriqueAssocie !== null) elb = elb.elementGeneriqueAssocie;
  var ind = CListeObjets.prototype.indexOf.call(this, elb);
  var liste = this.listePourImplementation;
  if (liste === null) return ind;
  if (ind < this.nbObjSources) {
    var eltbase = elb.elementAssocie;
    return liste.indexOf(eltbase);
  }
  else return this.indicePremierObjetPourImplementation + ind - this.nbObjSources;
};
// Modifié version 5.2. On passe un paramètre nVersion qui représente le N° de version de la liste à partir de laquelle le prototype est chargé
CPrototype.prototype.read = function(inps, nVersion) {
  this.numeroVersionPrototype = inps.readInt();
  if (this.numeroVersionPrototype < 3) this.numeroVersion = 7; // Version 4.4
  else if (this.numeroVersionPrototype === 4) this.numeroVersion = 11;
  else if (this.numeroVersionPrototype === 5) this.numeroVersion = 15;
  else this.numeroVersion = nVersion;

  this.nom = inps.readUTF();
  this.commentaire = inps.readUTF();
  this.nbObjSources = inps.readInt();
  this.nbObjFinaux = inps.readInt();
  this.natureSources = inps.readByte();
  CListeObjets.prototype.readPourProtoDepuisFlux.call(this, inps);
};
CPrototype.prototype.write = function(oups){
  // Important : quand on enregistre le prototype dans un flux il faut que son membre
  // listePourImplementation soit null car sinon ce ne sont pas les bons indices des objets
  // contenus dans le prototype qui vont être enregistrés.
  this.listePourImplementation = null;
  oups.writeInt(numeroVersionPrototypes);
  oups.writeUTF(this.nom);
  oups.writeUTF(this.commentaire);
  oups.writeInt(this.nbObjSources);
  oups.writeInt(this.nbObjFinaux);
  oups.writeByte(this.natureSources);
  CListeObjets.prototype.writePourProtoDepuisFlux.call(this, oups);
};
// Ajout vesion 4.8
/**
 * Affecte listePourImplementation à this.listePourImplementation
 * @param {CListeObjets} listePourImplementationInit
 * @returns {undefined}
 */
CPrototype.prototype.setListePourImplementation = function(listePourImplementationInit) {
  this.listePourImplementation = listePourImplementationInit;
};



// WEBPACK FOOTER //
// ./src/objets/CPrototype.js